import { useHistory, useLocation } from "react-router-dom";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";
import { usePaymentInstructions } from "../../../PaymentInstructionsContext";
import { PaymentBeneficiary } from "../../../types";
import { beneficiaryEditIcon, beneficiaryViewContainer } from "../styles_vanilla.css";

export const BeneficiaryView = ({
  paymentBeneficiary,
}: {
  paymentBeneficiary: PaymentBeneficiary;
}) => {
  const { readonly, caseType, paymentAccountId } = usePaymentInstructions();
  const history = useHistory();
  const location = useLocation();

  const handleEditBeneficiary = () => {
    if (caseType === ComplianceCaseTypeEnum.PaymentInstructionChangeReview) {
      history.push(`${location.pathname}/edit-full-screen/${paymentAccountId}`);
      return;
    }
    history.push(`${location.pathname}/edit/${paymentBeneficiary?.id}`);
  };

  return (
    <Flex
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      data-testid="beneficiary-info"
      className={beneficiaryViewContainer}
    >
      <Flex flexDirection="row" gap={Sizes.SM} alignItems="center">
        <Icon type="user" data-testid="icon-user" />
        <Text>{paymentBeneficiary.name}</Text>
      </Flex>
      {!readonly && (
        <Icon
          type="edit"
          data-testid="icon-edit"
          color={Colors.Primary600}
          className={beneficiaryEditIcon}
          onClick={handleEditBeneficiary}
        />
      )}
    </Flex>
  );
};
